import { useQuery } from '@tanstack/react-query';
import type { Brief } from '@seo/types';
import { apiGet } from '@/lib/api';
import { isTerminal } from '@/lib/queryClient';
import type { BriefInsights } from './insights-types';

export function useBrief(id: string | undefined) {
  return useQuery({
    queryKey: ['brief', id],
    queryFn: () => apiGet<Brief>(`/v1/briefs/${id}`),
    enabled: !!id,
    refetchInterval: (q) => {
      const data = q.state.data;
      if (!data) return false;
      // Active generation
      if (!isTerminal(data.status)) return 5_000;
      // Living-brief refresh: poll until stale flags clear
      if ((data.stale_sections?.length ?? 0) > 0) return 5_000;
      return false;
    },
  });
}

export function useBriefInsights(id: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['brief-insights', id],
    queryFn: () => apiGet<BriefInsights>(`/v1/briefs/${id}/insights`),
    enabled: !!id && enabled,
  });
}
